<template>
  <div class="dash-preview">
    <div class="container">
      <b-modal id="modal-checkin-options"
               modal-class="modal-mobile-fullscreen modal-checkin-options"
               footer-class="modal-footer-fixed"
               centered
               size="md" no-close-on-backdrop
      >
        <template v-slot:modal-header>
          <h1 class="modal-title" v-if="data.question">{{ data.question }}</h1>
          <template v-else>
            <div class="placeholder__text mx-auto"
                 style="width: 180px;height: 12px;background: #FFFFFF;opacity:.2;"></div>
          </template>
        </template>
        <div class="text-center d-flex align-items-center justify-content-center h-100" style="padding-bottom: 40px">
          <ul class="list-unstyled options w-100">
            <template v-if="data.options && data.options.length > 0">
              <li v-for="option in data.options" :key="option.id" class="option">
                <a href="#" @click.prevent="setOption(option)"
                   :class="['link-option', {'on': option.id === selectedOptionId}]">
                  <div class="content-option">
                    <div class="image-option" v-if="option.image">
                      <img :src="option.image_url" :alt="option.name">
                    </div>
                    <div class="name-option" v-if="option.name">{{ option.name }}</div>
                    <div class="description-option" v-if="option.description">{{ option.description }}</div>
                  </div>
                </a>
              </li>
            </template>
            <template v-else>
              <li v-for="index in 2" :key="index" class="option">
                <div class="link-option">
                  <div class="content-option">
                    <div class="image-option">
                      <div class="placeholder__text mx-auto"
                           style="width: 60px;height: 60px;background: #FFFFFF;opacity:.2;margin-bottom: 12px"></div>
                    </div>
                    <div class="name-option">
                      <div class="placeholder__text mx-auto"
                           style="width: 80px;height: 12px;background: #FFFFFF;opacity:.2;margin-bottom: 6px"></div>
                    </div>
                    <div class="description-option">
                      <div class="placeholder__text mx-auto"
                           style="width: 140px;height: 12px;background: #FFFFFF;opacity:.2;margin-bottom: 6px"></div>

                    </div>
                  </div>
                </div>
              </li>
            </template>
          </ul>
        </div>

        <template v-slot:modal-footer>
          <b-button variant="primary" block
                    :disabled="!selectedOptionId">
            {{ $t('modal_checkin_options.action_confirm') }}
          </b-button>
        </template>
      </b-modal>
    </div>
  </div>
</template>


<script>
export default {
  name: 'PreviewCheckinOptions',
  props: {
    data: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      selectedOptionId: null,
    }
  },
  async mounted() {
    await this.$nextTick()
    this.$bvModal.show('modal-checkin-options')
  },
  methods: {
    setOption(option) {
      this.selectedOptionId = (option.id === this.selectedOptionId) ? null : option.id
    }
  }
}
</script>
